module.exports = __webpack_public_path__ + "static/doctor-talk-6f2db7f008de19eb3e096f9eaedfcb40.png";